module.exports = __webpack_public_path__ + "static/media/down.e5bc8d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/down.png
// module id = 2119
// module chunks = 0